import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  private baseURL = 'https://akceso07.nine.ch/verity';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let url = req.url;
    const isDifferentUrl = url.startsWith('http');

    if (!isDifferentUrl && !url.startsWith('/')) {
      url = '/' + url;
    }

    let body = '';

    if (req['method'] === 'POST') {
        if (url.indexOf('checklogin') === -1) {
            Object.keys(req.body).forEach(key => {
                body += '&' + key + '=' + req.body[key];
            });
        }
    }

    const user = localStorage.getItem('verity_user');
    const token = localStorage.getItem('verity_token');

    let payLoad = '';

    if (user && token) {
      payLoad = 'user=' + user + '&token=' + token + body;
    } else {
      payLoad = body.substr(1);
    }

    req = req.clone({
      url: isDifferentUrl ? req.url : this.baseURL + url,
      headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded'),
      body: payLoad
    });

    return next.handle(req);
  }
}
